import { Message, MessageBox } from 'element-ui'
import * as Sentry from '@sentry/vue'
import { getcarAuditRecord, readyLease, stockLogFindLastOne, updateOperateState } from '@/api/domain/cars'
import { jumpMap } from '../../vehicleManage/dict'

// Tab枚举
export const TABS = {
  All: 'all',
  WaitForInput: 'waitForInput',
  WaitForHandle: 'waitForHandle',
  WaitForRent: 'waitForRent',
  AfterRent: 'afterRent',
  OutCar: 'outCar',
}

// Tab配置
export const tabList = {
  [TABS.All]: {
    name: '全部车辆',
    params: { exitOperationState: 0 },
  },
  [TABS.WaitForInput]: {
    name: '待入库',
    description: '已经在车务中心平台上完成车辆创建，但是还未完成 确认到库 操作的车辆，此时状态为待入库。',
    params: { carState: 5, exitOperationState: 0 },
  },
  [TABS.WaitForHandle]: {
    name: '待处理',
    description: '车辆存在待办项，包括但不限于车辆信息不全、车辆存在未处理事故任务、车辆存在未处理维修任务等。',
    params: { carState: 10, exitOperationState: 0 },
  },
  [TABS.WaitForRent]: {
    name: '待租',
    description: '车辆的所有信息全部完善，未存在待处理任务时，车辆状态为待租。待租状态下的车辆可对外出租给个人或企业。',
    params: { carState: 20, exitOperationState: 0 },
  },
  [TABS.AfterRent]: {
    name: '已租',
    description: '若车辆存在租赁中的订单，且未做退车入库的情况下，此时车辆状态为已租。平台会对已租状态下的车辆收取一定技术服务费。',
    params: { carState: 40, exitOperationState: 0 },
  },
  [TABS.OutCar]: {
    name: '退出运营',
    description: '在车辆无租赁中订单时，可对车辆操作退出运营，操作后车辆状态即为退出运营。若想再次将车辆恢复至可租赁状态，只要完成恢复运营即可。',
    params: { exitOperationState: 1 },
  },
}

//  跳转详情
export const gotoDetail = (router) => {
  return function (row) {
    const { id, plateNo, companyId } = row
    router.push({
      path: '/vehicle/vehicleManage/detail',
      query: {
        id,
        plateNo,
        companyId,
      },
    })
  }
}

// 跳转编辑
export const gotoEdit = (router, routeName) => {
  return function (row) {
    if (!routeName) {
      Sentry.captureException('编辑「车辆信息」方法入参有问题，routeName未传入')
      return
    }
    const { basicItemState, id, companyId } = row
    if (basicItemState === 3) {
      const str =
        '审核中，车辆不可编辑信息，提示车辆信息审核中，请审核结束后再修改'
      MessageBox.confirm(str, '提示', {
        confirmButtonText: '确定',
        callback: () => {},
      })
    } else {
      router.push({
        name: routeName,
        query: {
          id,
          companyId,
        },
      })
    }
  }
}

// 发车
export const exportCar = (router) => {
  return async function (row) {
    const { id, companyId } = row
    // 获取出入库记录
    const { code, data } = await stockLogFindLastOne({ carId: id, type: 1 })
    if (code !== 1) return

    const queryObj = {
      id,
      type: 1, // 发车
      companyId,
    }

    // 出入库状态 0:待处理，1:已完成，2:已作废
    if (data && Number(data.state) === 0) {
      queryObj.stockId = data?.id
    }
    router.push({
      path: '/vehicle/outInStorage/edit/outCar',
      query: { ...queryObj },
    })
  }
}

// 保养
export const maintenance = (router) => {
  return function (row) {
    router.push({
      path: '/vehicle/maintenance/add',
      query: { type: 2, plateNo: row.plateNo },
    })
  }
}

// 维修
export const repair = (router) => {
  return function (row) {
    router.push({
      path: '/vehicle/maintenance/add',
      query: { type: 1, plateNo: row.plateNo },
    })
  }
}

// 事故
export const accident = (router) => {
  return function (row) {
    router.push({
      path: '/vehicle/accident/add',
      query: { plateNo: row.plateNo },
    })
  }
}

// 备车、取消备车
export const prepareCar = (state, cb) => {
  return async function (row) {
    const { id, companyId } = row
    const { code } = await readyLease({
      id,
      readyLeaseState: state,
      companyId,
    })
    if (code !== 1) return
    Message.success(`${state ? '车辆已设置为' : '已操作取消'}备车`)
    cb && cb()
  }
}

// 上保险
export const insure = (addInsuranceShow, carPlateNo) => {
  return function (row) {
    addInsuranceShow.value = true
    carPlateNo.value = row.plateNo
  }
}

// 上证照
export const recordPhoto = (router) => {
  return function (row) {
    const { id, companyId } = row
    router.push({
      name: 'vehicle_licences_list_create',
      query: { id, companyId },
    })
  }
}

// 确认到库
export const confirmInput = (router) => {
  return function (row) {
    const { id, companyId } = row
    router.push({
      name: 'vehicle_list_edit',
      query: {
        id,
        companyId,
        action: 'confirmCarInStore',
      },
    })
  }
}

// 点击车辆信息审批状态
export const infoClick = (router) => {
  return function (item) {
    // 车辆状态为【待入库】&& 车辆基本信息状态【待提交】
    if (item.basicItemState === 2 && item.carState === 5) {
      Message.error('请先操作车辆确认到库')
      return
    }
    router.push({
      path: '/vehicle/vehicleManage/detail',
      query: {
        id: item.id,
        source: 'detail',
        companyId: item.companyId,
      },
    })
  }
}

// 恢复运营
export const restoreOperate = (cb) => {
  return function (row) {
    MessageBox({
      title: '提示',
      message: '确定要将此车辆恢复运营吗',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      beforeClose: (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true
          const { id, companyId } = row
          updateOperateState({
            id,
            companyId,
            exitOperationState: 0,
          }).then((res) => {
            if (res.code === 1) {
              Message.success('操作成功')
              cb && cb()
              done()
            }
          }).finally(() => { instance.confirmButtonLoading = false })
        } else {
          done()
        }
      },
    }).catch(() => {})
  }
}

// 退出运营
export const exitOperate = (disposalShow, carPlateNo, carId, vin, carState, dealCarCompanyId) => {
  return function (row) {
    const { plateNo: selectedPlateNo, id, vin: selectedVin, carState: selectedCarState, companyId } = row
    disposalShow.value = true
    carPlateNo.value = selectedPlateNo
    carId.value = id
    vin.value = selectedVin
    carState.value = selectedCarState
    dealCarCompanyId.value = companyId
  }
}

// 信息提交
export const submitInfo = (cb) => {
  return function (row) {
    const { id, companyId } = row
    MessageBox.confirm('确定要将此车辆信息提交吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    }).then(async () => {
      const { code } = await getcarAuditRecord({
        carId: id,
        type: 1,
        companyId,
      })
      if (code === 1) {
        Message.success('车辆信息提交成功')
        cb && cb()
      }
    }).catch(() => {})
  }
}

// 退车
export const returnCar = (router) => {
  return async function (row) {
    const { id, state, companyId } = row
    const { code, data } = await stockLogFindLastOne({
      carId: id,
      type: 2,
      state,
    })
    if (code !== 1) return
    // state（出入库状态）0：待处理
    if (data && Number(data.state) === 0) {
      router.push({
        path: '/vehicle/outInStorage/edit',
        query: {
          carId: id,
          type: 2, // 退车
          stockId: data.id,
          companyId: data.companyId,
        },
      })
    } else {
      router.push({
        name: 'carOperationOutInAdd',
        query: {
          carId: id,
          type: 2,
          companyId,
        },
      })
    }
  }
}

// 跳转待办
export const goTodo = (router, data) => {
  return function (todoItem) {
    // 2-正常，纯展示
    if (todoItem.itemState === 2) return
    // itemState-车辆待租标准具体状态 1-未填写或异常 2-正常 3-临近 4-超过
    if (todoItem.itemState === 1 || todoItem.itemState === 3 || todoItem.itemState === 4) { // 超期的需要去处理
      const jumpConf = jumpMap[todoItem.itemType]
      if (!jumpConf) {
        Sentry.captureException(`跳转配置缺少此种情况: itemType=${todoItem.itemType}，请和服务同学拉齐，补齐跳转枚举`)
        return
      }
      const queryObj = {}
      jumpConf.queryKey.forEach((key) => {
        if (key.split('=').length > 1) {
          queryObj[key.split('=')[0]] = key.split('=')[1]
        } else {
          queryObj[key] = data[key]
        }
      })
      router.push({
        path: jumpConf.url,
        query: queryObj,
      })
    }
  }
}

// 跳转详情
export const viewDetail = (router) => {
  return function (row) {
    const { id, companyId } = row
    const routeUrl = router.resolve({
      path: '/vehicle/vehicleManage/detail',
      query: { id, companyId },
    })
    window.open(routeUrl.href, '_blank')
  }
}

// 编辑不可租标签
export const editUnRentableTags = (dialogVisible, dealCarCompanyId, carId, checkedList) => {
  return function (row) {
    const { id, companyId, tagVOList } = row
    dialogVisible.value = true
    dealCarCompanyId.value = companyId
    carId.value = id
    if (Array.isArray(tagVOList)) {
      checkedList.value = tagVOList.map((item) => {
        return item.id
      })
    } else {
      checkedList.value = []
    }
  }
}

// 操作集合
export const operationUtils = (permission, router, context) => {
  return {
    lookCarDetail: {
      label: '详情',
      judgePermission: (row) => permission('vehicle_list_detail') && [5, 10, 15, 20, 40].includes(row.carState),
      handler: gotoDetail(router),
    },
    editCar: {
      label: '编辑',
      judgePermission: (row) => permission('vehicle_list_edit') && [5, 10, 15, 20, 40].includes(row.carState),
      handler: gotoEdit(router, context?.routeName),
    },
    outCar: {
      label: '发车',
      judgePermission: (row) => permission('vehicle_list_dispatch_car') && Number(row.stockButtonState) === 1,
      handler: exportCar(router),
    },
    careCar: {
      label: '保养',
      judgePermission: (row) => permission(context?.careCarKey) && [10, 20, 40].includes(row.carState) && row.plateNo,
      handler: maintenance(router),
    },
    fixCar: {
      label: '维修',
      judgePermission: (row) => permission(context?.fixCarKey) && [10, 20, 40].includes(row.carState) && row.plateNo,
      handler: repair(router),
    },
    accidentCar: {
      label: '事故',
      judgePermission: (row) => permission(context?.accidentCarKey) && [10, 15, 20, 40].includes(row.carState) && row.plateNo,
      handler: accident(router),
    },
    prepareCar: {
      label: '备车',
      // 权限控制- 有此「vehicle_list_ready_lease」权限 && 车辆标签数据不包含'已备车' && 车辆状态为待租
      judgePermission: (row) => permission('vehicle_list_ready_lease') && row.carState === 20 && ((row?.tagList?.length && !row.tagList.includes('已备车')) || !row.tagList.length),
      handler: prepareCar(1, context?.getCarList),
    },
    addInsure: {
      label: '上保险',
      judgePermission: (row) => permission('vehicle_list_insurance') && [10, 15, 20, 40].includes(row.carState) && row.plateNo,
      handler: insure(context?.addInsuranceShow, context?.carPlateNo),
    },
    addLicense: {
      label: '上证照',
      judgePermission: (row) => permission(context?.addLicenseKey) && [15, 40].includes(row.carState),
      handler: recordPhoto(router),
    },
    confirmCarInStore: {
      label: '确认到库',
      judgePermission: (row) => {
        if (context?.confirmCarInStoreKey) {
          return permission(context?.confirmCarInStoreKey) && row.carState === 5
        }
        return row.carState === 5
      },
      handler: confirmInput(router),
    },
    cancelPrepareCar: {
      label: '取消备车',
      judgePermission: (row) => permission('vehicle_list_ready_lease') && row.carState === 20 && row?.tagList?.length && row.tagList.includes('已备车'),
      handler: prepareCar(0, context?.getCarList),
    },
    dealCar: {
      label: '退出运营',
      judgePermission: (row) => permission('vehicle_list_exit_operations') && ([5, 10, 15].includes(Number(row.carState)) || ([20].includes(Number(row.carState)) && Number(row.lockedState) !== 1)),
      handler: exitOperate(context?.disposalShow, context?.carPlateNo, context?.carId, context?.vin, context?.carState, context?.dealCarCompanyId),
    },
    carInfoSubmit: {
      label: '车辆信息提交',
      judgePermission: (row) => permission('vehicle_list_submit') && [10, 15, 20, 40].includes(row.carState) && Number(row.basicItemState) === 2,
      handler: submitInfo(context?.getCarList),
    },
    infoClick: {
      label: '车辆基本信息状态',
      handler: infoClick(router),
    },
    restoreOperate: {
      label: '恢复运营',
      judgePermission: () => permission('vehicle_list_resume_operations'),
      handler: restoreOperate(context?.getCarList),
    },
    returnCar: {
      label: '退车',
      judgePermission: (row) => permission('vehicle_list_stock_edit') && Number(row.stockButtonState) === 2,
      handler: returnCar(router),
    },
    viewDetail: {
      judgePermission: permission('vehicle_list_detail'),
      handler: viewDetail(router),
    },
    editUnRentableTag: {
      handler: editUnRentableTags(context?.dialogVisible, context?.dealCarCompanyId, context?.carId, context?.notRentableTags),
    },
  }
}

